export const EDIT_LANG = "EDIT_LANG";